module.exports = __webpack_public_path__ + "static/media/home-img.b7340a70.png";